import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { CONSTANT, getConstant } from '../../../utils/constants';
import { ChevronDownIcon } from 'primereact/icons/chevrondown';
import { ChevronRightIcon } from 'primereact/icons/chevronright';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { privateFetch } from '../../../utils/apiHelper';
import { validateURL } from '../../../utils/stringHelper';
import { Message } from 'primereact/message';
import FormInput from './FormInput';
import UrlCard from '../Display/UrlCard';

function MultipleUrlsInput({ urlList, setUrlList }) {
  const [type, setType] = useState(CONSTANT.backoffice.residency.urlType[0].value);
  const [label, setLabel] = useState('');
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);

  const createUrl = async (urlForm) => {
    setLoading(true);
    await privateFetch('POST', `/url/`, null, JSON.stringify(urlForm)).then((res) => {
      setLoading(false);
      setUrlList([...urlList, res]);
      setLabel('');
      setLink('');
      setType(CONSTANT.backoffice.residency.urlType[0].value);
    });
  };

  const removeUrl = (targetUrl) => {
    setUrlList(urlList.filter((url) => url !== targetUrl));
  };

  const onValidate = () => {
    const urlForm = {
      label,
      link,
      type
    };
    createUrl(urlForm);
  };

  const formIsValid = validateURL(link) && label && type;

  const dropdownTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex items-center gap-2">
          <i className={`pi ${option.icon}`}></i>

          <div>{option.label}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const dropdownOptionTemplate = (option) => {
    return (
      <div className="flex items-center gap-2">
        <i className={`pi ${option.icon}`}></i>

        <p>{option.label}</p>
      </div>
    );
  };

  return (
    <>
      <FormInput key="url" label={'Ajouter un lien externe'}>
        <div className="flex flex-col gap-3 w-full ">
          <div className="flex flex-row gap-3 w-full items-center">
            <Dropdown
              value={type}
              onChange={(e) => setType(e.value)}
              options={CONSTANT.backoffice.residency.urlType}
              optionLabel="label"
              placeholder="Selectionnez un type"
              valueTemplate={dropdownTemplate}
              itemTemplate={dropdownOptionTemplate}
              dropdownIcon={(opts) => {
                return opts.iconProps['data-pr-overlay-visible'] ? (
                  <ChevronRightIcon {...opts.iconProps} />
                ) : (
                  <ChevronDownIcon {...opts.iconProps} />
                );
              }}
            />

            <InputText
              placeholder="Nom du lien"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              type={label}
              className="grow"
            />

            <InputText
              placeholder="https:// ou http://"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              className="grow"
            />
            {type && (
              <Button
                icon="pi pi-plus"
                rounded
                severity="success"
                onClick={onValidate}
                disabled={!formIsValid}
                loading={loading}
                className="h-10 w-10 min-w-10 min-h-10"
              />
            )}
          </div>
          {!validateURL(link) && (
            <Message
              text="L'URL doit commencer par http:// ou https://"
              className="w-full"
              severity="error"
            />
          )}
        </div>
      </FormInput>

      {urlList?.map((url) => (
        <UrlCard key={url.id} url={url} removeUrl={() => removeUrl(url)} />
      ))}
    </>
  );
}

export default MultipleUrlsInput;
